export const leat = {
  seo: {
    title: 'Leat loyalty integration | Bistroo',
    description: 'Start a loyalty programme for your restaurant via Leat and Bistroo. Customers automatically earn points with every online order.',
  },
  hero: {
    category: 'Loyalty programme',
    description: 'Let customers automatically earn loyalty points with every Bistroo order. More repeat purchases, a loyal customer base and higher revenue.',
  },
  about: {
    title: 'What does Leat do?',
    p1: 'Leat (Loyalty, Engagement, Acquisition & Technology) is a smart loyalty and marketing platform built specifically for the restaurant industry. With Leat you build your own rewards programme where customers earn points, receive rewards and come back for more.',
    p2: 'Via the Bistroo × Leat connection, loyalty points are automatically credited with every online order. Customers see their points balance in the app and can redeem rewards directly on their next order. You manage the programme entirely from the Leat dashboard.',
    stats: [
      { value: '+30%', label: 'higher order frequency' },
      { value: '2×', label: 'higher customer value' },
      { value: '85%', label: 'customer retention' },
    ],
    benefits_title: 'What does the connection deliver?',
    benefits: [
      'Automatic loyalty points with every online order',
      'Customers redeem points as payment',
      'Targeted marketing campaigns via the Leat platform',
      'Insight into customer behaviour and purchase patterns',
      'Points also redeemable in the restaurant itself',
    ],
  },
  wordcloud_title: 'Leat at a glance',
  wordcloud: ['Loyalty programme', 'Reward points', 'Customer retention', 'Rewards', 'Marketing platform', 'Customer data', 'Campaigns', 'Customer engagement', 'Repeat purchases', 'Redeem points', 'GDPR-compliant', 'Restaurant marketing', 'Engagement', 'Retention', 'Segmentation'],
  usp: {
    heading: 'Why connect Bistroo to Leat?',
    items: [
      { icon: 'bi-star-fill', title: 'Automatic points earning', text: 'Every order via Bistroo immediately credits loyalty points to the customer\'s Leat account. No manual actions, no hassle.' },
      { icon: 'bi-arrow-repeat', title: 'More repeat purchases', text: 'Customers with loyalty points order on average 2× more often. Leat gives them a reason to come back, Bistroo makes ordering easy.' },
      { icon: 'bi-megaphone-fill', title: 'Targeted campaigns', text: 'Send personalized offers to customers via Leat based on their order history from Bistroo. Exactly at the right moment.' },
      { icon: 'bi-graph-up-arrow', title: 'Loyalty insights', text: 'See in one dashboard how many points are outstanding, who your most loyal customers are and which rewards are redeemed most.' },
      { icon: 'bi-share-fill', title: 'Customers as ambassadors', text: 'LEAT supports referral rewards. Satisfied customers who refer friends earn extra points, you receive new guests without advertising costs.' },
      { icon: 'bi-gift-fill', title: 'Rewards that motivate', text: 'Set rewards that suit your restaurant: from a free drink to a discount on the next order. Guests strive for the goal and order more often.' },
    ],
  },
  setup: {
    heading: 'How to start your loyalty programme with Leat',
    steps: [
      'Create a Leat account and set up your loyalty programme (name, brand color, earning rule).',
      'Open the Leat management panel and copy your API key.',
      'Go to Bistroo Merchant Portal → Integrations → Leat.',
      'Enter the Leat API key and link your customer database.',
      'Set your earning rule (e.g. 1 point per €1 spent) and activate the programme.',
    ],
  },
  faq: {
    items: [
      { q: 'How do customers automatically earn points?', a: 'As soon as a customer places an order via your Bistroo webshop and pays, loyalty points are automatically credited to their Leat account. The customer receives a notification via the Leat app or email.' },
      { q: 'Can customers also redeem points in the restaurant itself?', a: 'Yes. Via the Leat POS app, customers can use their points for a purchase at the counter. Points are therefore usable both online (via Bistroo) and offline.' },
      { q: 'How do I set up rewards?', a: 'In the Leat dashboard you define the rewards yourself: a free drink, a discount on the next order, or a special treat. You decide how many points are needed for each reward.' },
      { q: 'Is customer data protected under GDPR?', a: 'Yes. Leat is fully GDPR-compliant and stores customer data within the European Union. Customers give explicit consent to participate in the loyalty programme.' },
      { q: 'Can I send marketing campaigns from Leat?', a: 'Yes. Leat offers integrated email and push notification campaigns. You can target customers based on their order history, points balance and purchase patterns.' },
    ],
  },
}
